import React, { useContext } from 'react';
import { css, SerializedStyles } from '@emotion/react';
import { motion } from 'motion/react';
import { useTranslation } from '@frontend/i18n';
import { Heading } from '@frontend/design-system';
import { SeeMoreOrLessButton, Summary, GridContainerContext } from '../components';
import { InsuranceReportContext } from '../dental-insurance-eligibility-report';
import { GridTableEnum } from '../types';
import { whiteRoundedBg } from './common-styles';

type MaximumsProps = {
  style?: SerializedStyles;
  isPrintingReport?: boolean;
};

export const Maximums = React.memo(({ style, isPrintingReport = false }: MaximumsProps) => {
  const { t } = useTranslation('insuranceEligibilityReport');
  const { shouldShowMaximums, maximumsSummary, selectedNetworkFilterValue } = useContext(InsuranceReportContext);
  const { selected, setSelected, selectedStyle, notSelectedStyle } = useContext(GridContainerContext);

  const isSelected = selected === GridTableEnum.MAXIMUM;
  const isNotSelected = !!selected && selected !== GridTableEnum.MAXIMUM;

  if (shouldShowMaximums) {
    return (
      <motion.div
        css={[
          containerStyle,
          whiteRoundedBg,
          isSelected && selectedStyle,
          isNotSelected && notSelectedStyle,
          style,
          isSelected && { height: 'fit-content' },
        ]}
        layout
      >
        <motion.div layout='position' css={headingContainerStyle}>
          <Heading level={2}>{t('Maximums')}</Heading>
          <SeeMoreOrLessButton
            onClick={() => setSelected(isSelected ? '' : GridTableEnum.MAXIMUM)}
            isSelected={isSelected}
          />
        </motion.div>
        <Summary
          applyFilters={!isPrintingReport}
          data={maximumsSummary || []}
          expanded={isSelected}
          noDataFoundMessage={t('No data found for {{selectedNetworkFilterValue}}', { selectedNetworkFilterValue })}
        />
      </motion.div>
    );
  }
  return null;
});

Maximums.displayName = 'Maximums';

const containerStyle = css`
  @media (max-width: 900px) {
    grid-column: 1/3;
  }
`;

const headingContainerStyle = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
